import {cs} from "../../../../../../../../../react/chain-services";
import * as React from "react";
import {MultiLevelSearch} from "./multi-level-search";
import "./search-view.scss";
import {BuildingsTable} from "../common/buildings-table/buildings-table";

export const SearchView = ({buildings, onAddBuilding, onRemoveBuilding, onRemoveAddresses, search}) => cs(
    ["searchResult", (_, next) => next(MultiLevelSearch({
        search,
        data: buildings,
        levels: [
            {
                getKey: (b) => b.building.key,
                targets: [
                    {
                        name: "name",
                        getText: (b) => b.building.name,
                    },
                ],
                getChildren: (b) => b.addressList,
            },
            {
                getKey: (a) => a.address2,
                targets: [
                    {
                        name: "address2",
                        getText: (a) => a.address2,
                    },
                ],
            },
        ],
    }))],
    ({searchResult}) => BuildingsTable({
        onAddBuilding,
        onRemoveBuilding,
        buildings: searchResult.map((sr) => buildings.find((b) => b.building.key === sr.key)),
        // renderBuildingName: (b) => { // Highlight search found
        //     const sr = searchResult.find((sr) => b.building.key === sr.key);
        //     return highlight(b.building.name, sr.matches[0]?.match.ranges);
        // },
        renderBuildingName: (b) => b.building.name,
        getAddresses: (b) => {
            const sr = searchResult.find((sr) => b.building.key === sr.key);
            return !sr.matches.length ? (
                sr.children.map((sr2) => {
                    const a = b.addressList.find((a) => a.address2 === sr2.key);
                    return ({key: a.address2, label: <>{a.address}, {highlight(a.address2, sr2.matches[0].match.ranges)}</>});
                })
            ) : (
                b.addressList.map((a) => ({key: a.address2, label: a.address + (a.address2 ? ", " + a.address2 : "")}))
            );
        },
        getInitExpandeds: () => searchResult.filter((r) => !r.matches.length).map((r) => r.key),
        onRemoveAddresses,
    }),
);

const highlight = (text, ranges) => {
    if (!ranges?.length) {
        return text;
    }
    let index = 0;
    let ret = [];
    for (const range of ranges) {
        if (range.from > index) {
            ret.push(text.substring(index, range.from));
        }
        ret.push(<em>{text.substring(range.from, range.to)}</em>);
        index = range.to;
    }
    if (text.length > index) {
        ret.push(text.substring(index));
    }
    return React.createElement(React.Fragment, {}, ...ret);
};
